export const GRID_SIZE = 10;
export const DRAG_Y_OFFSET = -80; 
export const COLORS = ['blue', 'purple', 'pink', 'emerald', 'amber', 'rose', 'indigo'];

export const COLOR_MAP = {
  blue: 'bg-blue-500',
  purple: 'bg-purple-500',
  pink: 'bg-pink-500',
  emerald: 'bg-emerald-500',
  amber: 'bg-amber-500',
  rose: 'bg-rose-500',
  indigo: 'bg-indigo-500',
};

export const LIGHT_COLOR_MAP = {
  blue: 'bg-blue-400/20',
  purple: 'bg-purple-400/20',
  pink: 'bg-pink-400/20',
  emerald: 'bg-emerald-400/20',
  amber: 'bg-amber-400/20',
  rose: 'bg-rose-400/20',
  indigo: 'bg-indigo-400/20',
};



export const SHAPES = [
  [[1]], // Dot
  [[1, 1]], // H-Line 2
  [[1, 1, 1]], // H-Line 3
  [[1, 1, 1, 1]], // H-Line 4
  [[1], [1]], // V-Line 2
  [[1], [1], [1]], // V-Line 3
  [[1], [1], [1], [1]], // V-Line 4
  [[1, 1], [1, 1]], // Square
  [[1, 1, 1], [1, 1, 1], [1, 1, 1]], // Big Square
  [[1, 0], [1, 1]], // L 2x2
  [[1, 1, 1], [1, 0, 0], [1, 0, 0]], // Big L
  [[0, 1, 0], [1, 1, 1]], // T
  [[1, 1, 0], [0, 1, 1]], // Z
  [[0, 1, 1], [1, 1, 0]], // S
];

export const generateRandomBlock = () => {
  const shapeIdx = Math.floor(Math.random() * SHAPES.length);
  const colorIdx = Math.floor(Math.random() * COLORS.length);
  return {
    id: Math.random().toString(36).substr(2, 9),
    shape: SHAPES[shapeIdx],
    color: COLORS[colorIdx],
  };
};

export const GameState = {
    grid: Array(GRID_SIZE).fill(null).map(() => Array(GRID_SIZE).fill(null)),
    score: 0,
    availableBlocks: [],
    isGameOver: false,
    combo: 0
}